export var InboxCountTypeEnum;
(function (InboxCountTypeEnum) {
    InboxCountTypeEnum["NONE"] = "none";
    InboxCountTypeEnum["UNREAD"] = "unread";
    InboxCountTypeEnum["UNSEEN"] = "unseen";
})(InboxCountTypeEnum || (InboxCountTypeEnum = {}));
//# sourceMappingURL=configuration.interface.js.map